<template>
  <div class="pdt-20px">
    <div class="card"
         id="detail-command">
      <div class="card-content details">
        <div class="is-pulled-left">
          <logo-agence
              v-if="(logoParAgence || devisCommande.regleFacturationId) && logo"
              :logo="logo">
          </logo-agence>
          <logo-societe v-else :societeId="devisCommande.societeId"></logo-societe>
        </div>
        <div class="reference">
          <p class="has-text-weight-bold is-size-3">{{ detailDevisCommande.code }}</p>
          <span>{{ detailDevisCommande.generalInfos.dateDevisCommande }}</span>
        </div>
        <div class="intervenant is-flex"
             :class="{'is-spaced-between': commercial}">
          <infos-commercial v-if="commercial"
                            :commercial="commercial"
                            :reference-client="detailDevisCommande.referenceClient"
                            :code-dossier="detailDevisCommande.codeDossier"/>
          <div class="has-text-right"
               :class="{'pull-right': !commercial}">
            <div v-if="mentionMandataire" class="has-text-weight-bold">
              {{ payeurSelected.titre ? payeurSelected.titre : payeurSelected.libelle }}
            </div>
            <div>
              <router-link-blank v-if="afficherLien"
                :to="{ name: 'c.bodac.clients/contacts-client',
                    params: {id: payeurSelected.tiersId}}"
                :message="intituleAdressePayeur"/>
              <span v-else>{{ intituleAdressePayeur }}</span>
            </div>
            <div>
              {{ payeurSelected.adressePostale.intitule2 }}
              <span v-if="mentionMandataire">
                {{ payeurSelected.adressePostale.intitule3 }}
              </span>
            </div>
            <div v-if="!mentionMandataire">
              {{ payeurSelected.adressePostale.intitule3 }}
            </div>
            <div> {{ payeurSelected.adressePostale.adresse1 }}</div>
            <div> {{ payeurSelected.adressePostale.adresse2 }}</div>
            <div> {{ payeurSelected.adressePostale.adresse3 }}</div>
            <div>
              {{ payeurSelected.adressePostale.codePostal }}
              <span v-if="payeurSelected.adressePostale.codePostal
              && payeurSelected.adressePostale.ville">
                -
              </span>
              {{ payeurSelected.adressePostale.ville }}
            </div>
            <div> {{ payeurSelected.adressePostale.pays }}</div>
          </div>
        </div>
        <small v-if="detailDevisCommande.reference">
          <router-link-blank
            :to="{ name: 'c.bodac.devis', params: {id: detailDevisCommande.reference.id}}"
            :message="$t('detail.commande.referenceDevis', {
                number: detailDevisCommande.reference.code,
                date: detailDevisCommande.reference.dateDevisCommande
                })"/>
        </small>
        <small v-if="devisCommande.planMediaId && modulePlanMediaActive">
          <router-link-blank
            v-if="devisCommande.planMedia"
            :to="{name: 'c.presse.plan_media', params: {id: devisCommande.planMediaId}}"
            :message="$t('detail.commande.planMediaReference',
            { numero: devisCommande.planMedia.code })"/>
        </small>
        <small v-if="modulePresseActive && devisCommande.regleFacturationId">
          {{ $t('detail.generalInfos.regleFacturation') }}
          {{ getLibelleRegleFacturation(devisCommande.regleFacturationId) }}
        </small>
        <infos-intervenant :intervenants="payeurSelected.annonceurs"
          :afficherLien="afficherLien"/>
        <infos-intervenant :intervenants="payeurSelected.donneursOrdre"
          :afficherLien="afficherLien"/>
        <infos-intervenant :intervenants="payeurSelected.intervenants"
          :afficherLien="afficherLien"/>
        <br>
        <detail-lignes-commande
          :masqueRemise="devisCommande.masqueRemise"
          :isEditPrevisu="isEditPrevisu"
          :isPrevisualisation="isPrevisualisation"
          :typeDCF="devisCommande.type"
          :lignes-commande="detailDevisCommande.lignesCommande"
          :afficherLien="afficherLien"
          @masqueLigneChange="$emit('masqueLigneChange', $event)"
          @masqueRemiseChange="$emit('masqueRemiseChange', $event)"/>
        <div class="summary-container">
          <div class="column is-4 is-paddingless">
            <repartitions-tva :repartitions-tva="detailDevisCommande.repartitionsTva"
                              v-if="devisCommande.montantTva !== 0"/>
            <br>
            <acomptes-affectes
              :payeurSelected='payeurSelected'
              :facturesAcompte="detailDevisCommande.acomptesAffectes"
              v-if="detailDevisCommande.acomptesAffectes.length > 0">
            </acomptes-affectes>
            <p class="is-size-7 mgb-20px" v-if="detailDevisCommande.tauxPenalite">
              {{ $t('detail.conditions.tauxPenalite') }}
              &nbsp;{{ detailDevisCommande.tauxPenalite }} %
            </p>
            <p v-if="detailDevisCommande.penalite" class="is-size-7 mgb-20px">
              <span v-if="devisCommande.textPenalite.length > 0"
                v-html="devisCommande.textPenalite"></span>
              <span v-else >{{ $t('detail.conditions.penalite') }}</span>
            </p>
            <template v-if="detailDevisCommande.recouvrement">
              <p class="is-size-7 mgb-20px">
                {{ $t('detail.conditions.recouvrement') }}
              </p>
            </template>
            <p v-if="detailDevisCommande.tauxEscompte" class="is-size-7 mgb-20px">
              {{ $t('detail.conditions.tauxEscompte') }}
              &nbsp;{{ detailDevisCommande.tauxEscompte }} %
            </p>
            <p v-if="detailDevisCommande.escompte" class="is-size-7 mgb-20px">
              {{ $t('detail.conditions.escompte') }}
            </p>
            <div v-if="detailDevisCommande.commentaire">
              <p class="has-text-weight-bold">
                {{ $t('detail.conditions.commentaires') }}
              </p>
              <p class="is-size-7 mgt-10px">
                {{ detailDevisCommande.commentaire }}
              </p>
            </div>
            <div v-if="detailDevisCommande.adresseLivraison">
              <p class="has-text-weight-bold">
                {{ $t('detail.conditions.adresseLivraison') }}
              </p>
              <p class="is-size-7 mgt-10px is-prewrap">{{
                detailDevisCommande.adresseLivraison }}
              </p>
            </div>
          </div>
          <div class="column is-4 is-paddingless">
            <recapitulatif-montants
              :recapitulatif="detailDevisCommande.recapitulatifMontants"/>
            <br>
            <repartition-recapitulatif-montants
              :recapitulatif="detailDevisCommande.recapitulatifMontants"
              :acomptes='detailDevisCommande.acomptesAffectes'
              :payeur="payeurSelected"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import logoSociete from '@/components/general/logoSociete';
import DetailLignesCommande from '@/components/devisCommandes/detailDevisCommande/detailLignesCommande';
import RepartitionsTva from '@/components/devisCommandes/detailDevisCommande/repartitionsTva';
import RecapitulatifMontants from '@/components/devisCommandes/detailDevisCommande/recapitulatifMontants';
import RepartitionRecapitulatifMontants from '@/components/devisCommandes/detailDevisCommande/repartitionRecapitulatifMontants';
import InfosCommercial from '@/components/devisCommandes/detailDevisCommande/infosCommercial';
import acomptesAffectes from '@/components/devisCommandes/detailDevisCommande/acomptesAffectes';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import InfosIntervenant from '@/components/devisCommandes/detailDevisCommande/infosIntervenant';
import { PARAMETRES_INTERNE_KEYS, PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { pGetAllPieceJointe } from '@/api/pieceJointes';
import { PIECE_JOINTE_TYPE_LOGO_FACTURE } from '@/configuration/general/pieceJointeConf';
import messageErreur from '@/services/general/messageErreur';
import { SENS_VENTE } from '@/configuration/devisConf';
import logoAgence from '@/components/general/logoAgence';

const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');

export default {
  props: {
    devisCommande: {
      type: Object,
      required: true,
    },
    detailDevisCommande: {
      type: Object,
      required: true,
    },
    payeurSelected: {
      type: Object,
      required: true,
    },
    isEditPrevisu: {
      type: Boolean,
      required: true,
    },
    isPrevisualisation: {
      type: Boolean,
      required: true,
    },
    afficherLien: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  components: {
    logoSociete,
    DetailLignesCommande,
    RecapitulatifMontants,
    RepartitionRecapitulatifMontants,
    RepartitionsTva,
    InfosCommercial,
    acomptesAffectes,
    routerLinkBlank,
    InfosIntervenant,
    logoAgence,
  },
  data() {
    return {
      logo: null,
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
      parametre: 'parametre',
    }),
    ...Societe.mapGetters({
      logoAgences: 'logoAgences',
    }),
    commercial() {
      if (this.detailDevisCommande.generalInfos && this.detailDevisCommande.generalInfos.commercial
        && this.detailDevisCommande.generalInfos.commercial.nom) {
        return this.detailDevisCommande.generalInfos.commercial;
      }
      return null;
    },
    reglesFacturation() {
      return this.parametre(PARAMETRES_KEYS.regleFacturation);
    },
    modulePresseActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.modulePresse.key);
    },
    intituleAdressePayeur() {
      if (this.payeurSelected.adressePostale && this.payeurSelected.adressePostale.intitule1) {
        return this.payeurSelected.adressePostale.intitule1;
      }
      return this.payeurSelected.nomCommercial;
    },
    mentionMandataire() {
      return (this.parametresInterne(PARAMETRES_INTERNE_KEYS.mentionMandataire.key)
        && this.payeurSelected.mandataire);
    },
    logoParAgence() {
      return (this.parametresInterne(PARAMETRES_INTERNE_KEYS.logoParAgence.key)
        && this.devisCommande.sens === SENS_VENTE);
    },
    modulePlanMediaActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.modulePlanMedia.key);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
      loadParametres: 'loadParametres',
    }),
    getLibelleRegleFacturation(regleId) {
      return this.reglesFacturation.find((regle) => regle.id === regleId)?.libelle ?? null;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.mentionMandataire.key]);
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.logoParAgence.key,
        PARAMETRES_INTERNE_KEYS.modulePlanMedia.key]);
      await this.loadParametres([PARAMETRES_KEYS.regleFacturation]);
      if (this.devisCommande.agenceId) {
        const logoAgence = this.logoAgences.find(logo => {
          return logo.elementId === this.devisCommande.agenceId;
        });
        this.logo = logoAgence ? (logoAgence.cheminMin || logoAgence.chemin) : null;
      }
      if (this.devisCommande?.regleFacturationId) {
        const logoDevisCommande = (await pGetAllPieceJointe({
          elementsId: [this.devisCommande.regleFacturationId],
        })).data.result.items.find(p => p.type.libelle === PIECE_JOINTE_TYPE_LOGO_FACTURE);
        this.logo = logoDevisCommande ? (logoDevisCommande.cheminMin || logoDevisCommande.chemin)
          : null;
      }
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>
